import { useEffect, useState } from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import * as Styles from './DownloadBanner.styles';
import useDeviceInfo from 'src/common/hooks/useDeviceInfo';
import { CloseRounded } from '@mui/icons-material';
import { DOWNLOAD_LINKS } from 'src/common/constants/links';

const DownloadBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { isMobile, isRunningInBrowser, userOperatingSystem } = useDeviceInfo();
  const downloadLink =
    userOperatingSystem === 'ios' ? DOWNLOAD_LINKS.IOS : DOWNLOAD_LINKS.ANDROID;

  useEffect(() => {
    if (isMobile && isRunningInBrowser) {
      setIsVisible(true);
    }
  }, [isMobile, isRunningInBrowser]);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible || !downloadLink) return null;

  return (
    <>
      <Box mt={8}></Box>
      <Styles.BannerContainer>
        <Styles.IconContainer src="/pari_icon.png" alt="App Icon" />
        <Styles.BannerText>
          <Typography
            fontWeight="fontWeightBold"
            variant="body1"
            lineHeight={1.3}
          >
            Pari
          </Typography>
          <Typography
            variant="body2"
            fontWeight="fontWeightRegular"
            fontSize="inherit"
            lineHeight={1.25}
          >
            ¡Descarga la app para una mejor experiencia!
          </Typography>
        </Styles.BannerText>
        <Button
          variant="contained"
          href={downloadLink}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ px: 3, mr: 0.5, color: 'white' }}
        >
          <Typography
            component="span"
            fontWeight="fontWeightMedium"
            color="#fff"
            variant="body2"
          >
            Descargar
          </Typography>
        </Button>
        <IconButton
          onClick={handleClose}
          sx={{ fontSize: '20px', paddingRight: 0 }}
        >
          <CloseRounded fontSize="inherit" />
        </IconButton>
      </Styles.BannerContainer>
    </>
  );
};

export default DownloadBanner;
